<template>

  <Header
    label="Einfach Freude verschenken"
    headline="DAS DA-Gutscheine"
  />

  <div v-if="items.length" class="py-24 container">
    <Vouchers
      :headline="null"
      :items="items"
    />
  </div>

  <Empty v-else text="Aktuell sind online keine Gutscheine verfügbar" />

</template>

<script>
import Layout from 'Web/Layouts/WithCart.vue';
import Vouchers from 'Web/Shared/Vouchers.vue';
import Button from 'Web/Shared/Button.vue';
import Header from 'Web/Shared/Header.vue';
import Empty from 'Web/Shared/Empty.vue';
import useMeta from '@/compose/meta';

export default {
  inheritAttrs: false,
  layout: Layout,
  components: {
    Vouchers,
    Button,
    Header,
    Empty,
  },
  props: {
    items: {
      type: Array,
      required: true,
    },
  },
  setup() {
    const { assign } = useMeta();

    assign({ title: 'DAS DA-Onlineshop - Gutscheine' });
  }
}
</script>
